import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f5f5f5",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        px: 3,
        textAlign: "center",
      }}
    >
      {/* 404 */}
      <Typography
        sx={{
          fontSize: 96,
          fontWeight: 700,
          color: "#F3DD3E",
          lineHeight: 1,
          mb: 1,
        }}
      >
        404
      </Typography>

      {/* Illustration */}
      <Box
        sx={{
          width: 120,
          height: 120,
          borderRadius: "50%",
          bgcolor: "#FFF8D6",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 3,
        }}
      >
        <Typography sx={{ fontSize: 56 }}>🔍</Typography>
      </Box>

      <Typography
        sx={{ fontSize: 20, fontWeight: 700, color: "#384F6F", mb: 1 }}
      >
        Page not found
      </Typography>

      <Typography
        sx={{ fontSize: 14, color: "#718198", mb: 4, maxWidth: 280 }}
      >
        The page you're looking for doesn't exist or has been moved.
      </Typography>

      <Button
        variant="contained"
        onClick={() => navigate("/")}
        sx={{
          bgcolor: "#F3DD3E",
          color: "#394867",
          fontWeight: 700,
          borderRadius: "10px",
          textTransform: "none",
          px: 4,
          py: 1.2,
          fontSize: 15,
          boxShadow: "none",
          "&:hover": {
            bgcolor: "#e5cf2e",
            boxShadow: "none",
          },
        }}
      >
        Go to Home
      </Button>

      <Button
        onClick={() => navigate(-1)}
        sx={{
          mt: 1.5,
          color: "#718198",
          textTransform: "none",
          fontSize: 14,
        }}
      >
        ← Go back
      </Button>
    </Box>
  );
};

export default NotFoundPage;